// @ts-nocheck
(function () {
  "use strict";

  function initTrigger(trigger) {
    var card = trigger.closest(".item-review-video");
    if (!card) return;
    var player = card.querySelector("[data-qbs-review-video-player]");
    var video = player ? player.querySelector("video") : null;

    trigger.addEventListener("click", function () {
      trigger.hidden = true;
      if (player) {
        player.hidden = false;
      }
      if (video) {
        video.play();
      }
    });

    if (video) {
      video.addEventListener("ended", function () {
        player.hidden = true;
        trigger.hidden = false;
        video.currentTime = 0;
      });
    }
  }

  function init() {
    document.querySelectorAll("[data-qbs-review-video-trigger]").forEach(initTrigger);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
